import {SplitStrategy, Strategy} from '../../../Business/calculateSplitTimes';
import {formatDistance} from '../../Support/Formatting/formatDistance';

export function formatSplitStrategy(strategy: SplitStrategy) {
    switch (strategy.strategy) {
        case Strategy.Distance:
            return formatDistance(strategy.distance).formatted + ' ' + formatDistance(strategy.distance).unit;
        case Strategy.Fraction:
            if (strategy.fraction.percentage === 100) {
                return 'No split';
            }
            return strategy.fraction.percentage.toFixed(0) + ' %';
    }
}
